import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FilterState } from '@ui/shared/domain-filter';

@Component({
    selector: 'ui-full-page-overlay',
    templateUrl: './full-page-overlay.component.html',
    styleUrls: ['./full-page-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class FullPageOverlayComponent {
    constructor(
        activeFilterService: FilterState,
    ) {
        activeFilterService.closeAllOverlays();
    }
}
